// @flow
type Time = {
  hours: number,
  minutes: number,
};

// https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm
function iso8601Duration({ hours, minutes }: Time): string {
  return `PT${hours}H${minutes}`;
}

export default iso8601Duration;
